import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { generateAccessToken, getBookings } from "../../Routes/ApiRoutes";
import CircularLoader from "../../utils/Loaders/CircularLoader";
import iconDelete from "../../assets/images/delete.svg";
import { reportListUrl, submitReportUrl } from "../../Routes/ApiRoutes.js";
import { Post, Get } from "../../Api/ApiMethods";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
import { uploadFile } from "react-s3";
import {
  BrowserRouter as Router,
  useHistory,
} from "react-router-dom";
import Arrow from "../../assets/images/arrow.svg";

export default function Maintenance() {
  const [bookingData, setBookingData] = useState([]);
  const [bookingId, setBookingId] = useState();
  const [accessToken, setAccessToken] = useState();
  const token = useSelector((state) => state.auth.isSignedIn);
  const [loader, setLoader] = useState(false);
  const [bookingIndex, setBookingIndex] = useState();
  const [reportList, setReportList] = useState([]);
  const config = {
    bucketName: process.env.React_App_S3_bucketName,
    dirName: "",
    region: process.env.React_App_S3_Region,
    accessKeyId: process.env.React_App_S3_AccessKeyId,
    secretAccessKey: process.env.React_App_S3_SecretAccessKey,
    s3Url: process.env.React_App_S3_Url,
  };
  const [data, setData] = useState({
    category_id: 0,
    message: "",
    attachments: [],
    slot_id: 0,
  });
  const [key, setKey] = useState([]);
  const [reportTypeError, setReportTypeError] = useState(null);
  const [addMsgError, setAddMsgError] = useState(null);

  useEffect(() => {
    fetchReportList();
  }, []);

  useEffect(() => {
    fetchBookings()
  }, []);

  // To return the accesstoken value when bookingId is selected.
  const fetchAccessToken = async (e) => {
  e.preventDefault();
   try {

      await Post(generateAccessToken, token, { booking_id: bookingId })
        .then((res) => {
          return setAccessToken(res?.data?.code);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("error in the fetch access token", error);
    }
  };

  const fetchBookings = () => {
    try {
      Get(getBookings, token)
        .then((res) => {
          if (res.status === 200) {
            setBookingData(res.data);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const bookingIdChange = (e) => {
    console.log("event in select", e.target.value);
    console.log("bookingData in select", bookingData.rows[e.target.value].id);
    setBookingId(bookingData.rows[e.target.value].id);
    setBookingIndex(bookingData.rows[e.target.value]);
  };

  const fetchReportList = () => {
    setLoader(true);
    try {
      Get(reportListUrl, token)
        .then((res) => {
          if (res.status === 200) {
            setReportList(res.data);
            setLoader(false);
          }
        })
        .catch((error) => {
          toast.error(error.error);
          setLoader(false);
        });
    } catch (error) {
      toast.error(error.error);
      setLoader(false);
    }
  };
  const handleReportTypeChange = (e) => {
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails);
    if (e.target.value === "0") {
      setReportTypeError("Report type is mandatory.");
    } else {
      setReportTypeError(null);
    }
  };

  const history = useHistory();

  const handleAdMsgChange = (e) => {
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails);
    if (e.target.value === "") {
      setAddMsgError("Additional message is mandatory.");
    } else if (e.target.value.length > 200) {
      setAddMsgError("Max length is 200 character.");
    } else {
      setAddMsgError(null);
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files) {
      var img = e.target.files;
      for (let i = 0; i < img.length; i++) {
        let imageArray = img[i].name.split(".");
        if (imageArray.length > 2 && imageArray.length < 2) {
          toast.error("Double extension files are not allowed.");
          setLoader(false);
        }
        // else if(imageArray[1] !== "jpeg" && imageArray[1] !== "jpg" && imageArray[1] !== "png" )
        // {
        //     setLoader(false);
        // 	toast.error("Only jpeg, jpg or png images are allowed.");
        // }
        else if (img[i].size > 5242880) {
          setLoader(false);
          toast.error("Max size should be less than 5MB.");
        } else {
          for (let j = 0; j < key.length; j++) {
            if (key[j].key === img[i].name) {
              toast.error("Image with same name already exist.");
              return;
            }
          }
          setLoader(true);
          let fl = img[i];
          uploadFile(fl, config)
            .then((d) => {
              let kk = key;
              let k = {
                key: d.key,
                location: d.location,
                type: d.key.split(".")[1].toString().toLowerCase(),
              };
              kk.push(k);
              setKey(kk);

              let updatedDetails = { ...data };
              let url = updatedDetails["attachments"];
              let ur = d.location;
              url.push(ur);
              setData(updatedDetails);
              setLoader(false);
            })
            .catch((err) => {
              toast.error(err.message);
              setLoader(false);
              e.target.value = "";
            });
        }
      }
      e.target.value = "";
    } else {
      toast.error("Please select an image.");
      setLoader(false);
      e.target.value = "";
    }
  };

  const deleteS3Object = async (key) => {
    return new Promise((resolve, reject) => {
      try {
        let s3bucket = new AWS.S3({
          dirName: "",
          accessKeyId: process.env.React_App_S3_AccessKeyId,
          secretAccessKey: process.env.React_App_S3_SecretAccessKey,
          Bucket: process.env.React_App_S3_bucketName,
        });
        var params = { Bucket: process.env.React_App_S3_bucketName, Key: key };
        s3bucket.deleteObject(params, function (err, data) {
          if (err) reject(err); // an error occurred
          else resolve(data); // successful response
        });
      } catch (e) {
        reject(e);
      }
    });
  };

  const handleDeleteImage = (val) => {
    setLoader(true);
    try {
      deleteS3Object(val.key)
        .then((response) => {
          let vl = key;
          let index = vl.findIndex((obj) => obj.key === val.key);
          vl.splice(index, 1);
          setKey(vl);

          let updatedDetails = { ...data };
          let url = updatedDetails["attachments"];
          let ind = url.findIndex((obj) => obj.key === val.key);
          url.splice(ind, 1);
          setData(updatedDetails);

          setLoader(false);
          toast.error("File removed.");
        })
        .catch((error) => {
          setLoader(false);
          toast.error("Something went wrong. Please try again later.");
          toast.error(error.error);
        });
    } catch (error) {
      setLoader(false);
      toast.error("Something went wrong. Please try again later.");
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setData({sort_id: bookingIndex?.slot_id})
    setLoader(true);
    data.slot_id = bookingIndex?.slot_id;
    fetchAccessToken(e);
    try {
      Post(submitReportUrl, token, data)
        .then((res) => {
          if (res.status === 200) {
            setLoader(false);
            setData({
              category_id: 0,
              message: "",
              attachments: [],
              slot_id: 0,
            });
            setKey([]);
            toast.success(res.message);
          }
        })
        .catch((error) => {
          toast.error(error.error);
          setLoader(false);
        });
    } catch (error) {
      toast.error(error.error);
      setLoader(false);
    }
  };


// All that like request for, you know maintenance code or access code that should be above the generate code. The additional message and the picture should all be up there, but the bottom button should be generate code, not report an issue.
  // console.log("bookingIndex in select", bookingIndex && bookingIndex?.slot_id);
  // console.log("accessToken in select", accessToken);
  return (
    <section className="generate-code-wrapper">
      <div className="container">
        <div className="generate-code">
          <div className="row no-gutters">
            <div className="col-md-8 col-sm-12 col-12 padding-rt">
              <div className="generate">
                <div className="row">
                  <h3>
                    <img onClick={history.goBack} src={Arrow} />
                  </h3>
                  <h3>Maintenance</h3>
                </div>
                <form>
                  <div className="form-group">
                    <label>Select your space</label>
                    <select className="form-control" onChange={bookingIdChange}>
                    <option value="0">Select</option>
                      {bookingData &&
                        bookingData?.rows?.map((i, index) => {
                          return (
                            <>
                              <option value={index}> {i.booking_code} </option>
                            </>
                          );
                        })}
                    </select>
                  </div>
                  <small>{bookingIndex?.slot?.description}</small>
                  {/* <div className="comman-btn payment">
                    <div className="text-wrap">
                      <p>Access code for vehicle maintainance</p>
                    </div>
                    <div className="row">
                      <button
                        onClick={(e) => {
                          fetchAccessToken(e);
                        }}
                      >
                        Generate code
                      </button>
                      <button>
                        {!!accessToken ? ( accessToken ): ""}
                      </button>
                    </div>
                  </div> */}
                  <div className="comman-btn payment pt-0">
                    <div className="text-wrap">
                      <h3>Services Provided</h3>
                    </div>
                    <section className="Report-issue-wrapper">
                      {loader && <CircularLoader />}
                      <div className="container">
                        <div className="Report-issue">
                          <div className="row no-gutters">
                            <div className="col-md-8 col-sm-12 col-12 padding-rt">
                              <div className="generate">
                                <div className="form-group">
                                  {/* <label>Select issue</label> */}
                                  <select
                                    className={
                                      reportTypeError
                                        ? "form-control borderRed"
                                        : "form-control"
                                    }
                                    onChange={handleReportTypeChange}
                                    id="category_id"
                                    value={data.category_id}
                                  >
                                    <option value="0">Select</option>
                                    {reportList &&
                                      reportList.map((item) => (
                                        <option
                                          key={item.category_id}
                                          value={item.category_id}
                                        >
                                          {item.category_name}
                                        </option>
                                      ))}
                                  </select>
                                  {reportTypeError && (
                                    <span className="form-error">
                                      {reportTypeError}
                                    </span>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Additional message</label>
                                  <input
                                    onChange={handleAdMsgChange}
                                    className={
                                      addMsgError
                                        ? "form-control borderRed"
                                        : "form-control"
                                    }
                                    placeholder="Write here"
                                    id="message"
                                    type="text"
                                    value={data.message}
                                  />

                                  {addMsgError && (
                                    <span className="form-error">
                                      {addMsgError}
                                    </span>
                                  )}
                                </div>

                                {key.length > 0 &&
                                  key.map((it) => {
                                    return (
                                      <div
                                        key={it.location}
                                        className="previewImage dis-b"
                                      >
                                        <span>
                                          <img
                                            onClick={() =>
                                              handleDeleteImage(it)
                                            }
                                            className="deleIcon"
                                            src={iconDelete}
                                          />
                                        </span>
                                        {it.type === "pdf" ? (
                                          <a target="_blank" href={it.location}>
                                            <iframe src={it.location} />
                                          </a>
                                        ) : it.type === "jpeg" ||
                                          it.type === "jpg" ||
                                          it.type === "png" ||
                                          it.type === "gif" ? (
                                          <a target="_blank" href={it.location}>
                                            <img
                                              src={it.location}
                                              alt={it.key}
                                            />
                                          </a>
                                        ) : (
                                          <a
                                            className="link"
                                            target="_blank"
                                            href={it.location}
                                          >
                                            {it.key}
                                          </a>
                                        )}
                                      </div>
                                    );
                                  })}
                                <div className="Upload-attachment">
                                  <div className="upload">
                                    <div className="Uploadtext">
                                      Upload attachment
                                    </div>
                                    <div
                                      onClick={() =>
                                        document
                                          .getElementById("attachments")
                                          .click()
                                      }
                                      className="UploadIcon"
                                    >
                                      +
                                      <input
                                        onChange={handleImageChange}
                                        id="attachments"
                                        type="file"
                                        multiple
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="d-inline-flex">
                                  <button onClick = {(e) => {handleSubmit(e)}}>
                                  Generate Code
                                  </button>
                                  <button>
                        {!!accessToken ? ( accessToken ): ""}
                      </button>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* <button>Report issue</button> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
